export default Object.freeze({
  Active: 1,
  Suspended: 2,
  Terminated: 3,
});
